//import Customer from "../../models/Customer";
import axios from "axios";
import { API_BASE_URL, FETCH_LIMIT } from "./../../globalVars";

const FETCH_LIMIT_CUSTOMER = 100;

export default {
  namespaced: true,

  actions: {
    async hydrate({ commit }, lastUpdateTime = null) {
      const store = this;
      const last = this.getters["entities/settings/query"]().first()
        .lastUpdateFromServer;
      await fetchNext({
        store: store,
        offset: 0,
        lastDateTime: lastUpdateTime ? lastUpdateTime : last
      });
    },

    async fetchCustomerDataJoins(
      context,
      { joins, customerId, startFresh = false }
    ) {
      let store = this;
      try {
        let response = await axios({
          method: "get",
          url: API_BASE_URL + `/customer`,
          params: {
            customerId: customerId,
            joins: joins
              ? joins
              : "addresses+contactInfos+messages+messagesScheduled+notes+otherInfos+appointments+chats+calls"
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        });
        let obj = response.data;
        store.dispatch("entities/insertOrUpdate", {
          entity: "customers",
          where: obj[0].id,
          data: obj[0]
        });
        if (obj[0].addresses) {
          store.dispatch("entities/insertOrUpdate", {
            entity: "addresses",
            data: obj[0].addresses
          });
        }
        if (obj[0].contactInfos) {
          store.dispatch("entities/insertOrUpdate", {
            entity: "contactInfos",
            data: obj[0].contactInfos
          });
        }
        if (obj[0].messages) {
          store.dispatch("entities/insertOrUpdate", {
            entity: "messages",
            data: obj[0].messages
          });
        }
        if (obj[0].messagesScheduled) {
          store.dispatch("entities/insertOrUpdate", {
            entity: "messagesScheduled",
            data: obj[0].messagesScheduled
          });
        }
        if (obj[0].notes) {
          store.dispatch("entities/insertOrUpdate", {
            entity: "notes",
            data: obj[0].notes
          });
        }
        if (obj[0].otherInfos) {
          store.dispatch("entities/insertOrUpdate", {
            entity: "otherInfos",
            data: obj[0].otherInfos
          });
        }
        if (obj[0].appointments) {
          store.dispatch("entities/insertOrUpdate", {
            entity: "appointments",
            data: obj[0].appointments
          });
        }
        if (obj[0].chatMessages) {
          store.dispatch("entities/insertOrUpdate", {
            entity: "chatMessages",
            data: obj[0].chatMessages
          });
        }
        // if (obj[0].calls) {
        //   store.dispatch("entities/insertOrUpdate", {
        //     entity: "calls",
        //     data: obj[0].calls
        //   });
        // }
        store.dispatch("entities/settings/setIsOffline", false);
      } catch (error) {
        store.dispatch("entities/settings/setIsOffline", true);
      }
    },

    async fetchCustomersDataJoins(context, { joins, customerIds }) {
      let store = this;
      try {
        let response = await axios({
          method: "post",
          url: API_BASE_URL + `/customer`,
          params: {
            joins: joins ? joins : "addresses+contactInfos"
          },
          data: {
            customerIds: customerIds
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`
          }
        });
        let obj = response;
        store.dispatch("entities/customers/insert", {
          data: obj
        });
        store.dispatch("entities/settings/setIsOffline", false);
      } catch (error) {
        store.dispatch("entities/settings/setIsOffline", true);
      }
    },

    async createCustomer(context, { customer, callback }) {
      if (customer.isDirty === true) {
        const store = this;
        try {
          let response = await axios({
            method: "post",
            url: API_BASE_URL + `/customer`,
            data: {
              accountId: customer.accountId,
              firstName: customer.firstName,
              middleName: customer.middleName,
              lastName: customer.lastName,
              companyName: customer.companyName,
              isBusiness: customer.isBusiness
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          let obj = response.data;
          await store.dispatch("entities/customers/delete", {
            where: customer.tempId
          });
          await store.dispatch("entities/customers/insert", {
            where: obj.id,
            data: obj
          });
          await store.dispatch("entities/users/update", {
            where: customer.userId,
            data: { currentCustomerId: obj.id }
          });
          let extraRecords = [];
          if (customer.contactInfo) {
            customer.contactInfo.customerId = obj.id;
            extraRecords.push(
              (function() {
                store.dispatch(
                  "entities/contactInfos/createContactInfo",
                  customer.contactInfo
                );
              })()
            );
          }
          if (customer.address) {
            customer.address.customerId = obj.id;
            extraRecords.push(
              (function() {
                store.dispatch(
                  "entities/addresses/createAddress",
                  customer.address
                );
              })()
            );
          }
          if (customer.otherInfo) {
            customer.otherInfo.customerId = obj.id;
            extraRecords.push(
              (function() {
                store.dispatch(
                  "entities/otherInfos/createOtherInfo",
                  customer.otherInfo
                );
              })()
            );
          }
          try {
            await Promise.all(extraRecords);
            await store.dispatch("entities/customerLookups/hydrate", 0);
            await store.dispatch("entities/customers/clickCustomer", {
              customerId: obj.id
            });
            if (callback) {
              callback(obj.id);
            }
            store.dispatch("entities/settings/setIsOffline", false);
          } catch (error) {
            store.dispatch("entities/settings/setIsOffline", true);
          }
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      } else {
        return false;
      }
    },
    async updateCustomer(context, customer) {
      if (customer.isDirty === true) {
        const store = this;
        let updateData = {
          accountId: customer.accountId,
          id: customer.id,
          firstName: customer.firstName,
          middleName: customer.middleName,
          lastName: customer.lastName,
          companyName: customer.companyName,
          isBusiness: customer.isBusiness,
          messagesArchivedAt: customer.messagesArchivedAt,
          messagesSnoozedUntil: customer.messagesSnoozedUntil
        };
        // if isRead then update viewedAt
        if (customer.isRead === true) {
          updateData.viewedAt = null;
        }
        try {
          let response = await axios({
            method: "patch",
            url: API_BASE_URL + `/customer/${customer.id}`,
            data: updateData,
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          let obj = response.data;
          store.dispatch("entities/customers/update", {
            where: obj.id,
            data: obj
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
          return false;
        }
      }
    },

    async deleteCustomer(context, customer) {
      const store = this;
      store.dispatch("entities/customers/delete", customer.id);
      store.dispatch("entities/customerLookups/delete", customer.id);

      if (customer.isDirty === true) {
        try {
          await axios({
            method: "patch",
            url: API_BASE_URL + `/customer/${customer.id}`,
            data: {
              accountId: customer.accountId,
              id: customer.id,
              deleted: true
            },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`
            }
          });
          store.dispatch("entities/settings/setIsOffline", false);
        } catch (error) {
          store.dispatch("entities/settings/setIsOffline", true);
        }
      }
    },

    async clickCustomer(context, { customerId, action, actionDate }) {
      let store = this;
      let accountId = store.state.entities.settings.data[1].accountId;
      let userId = store.state.entities.settings.data[1].userId;

      store.dispatch("entities/users/update", {
        where: userId,
        data: { currentCustomerId: customerId }
      });
      let updateCustomer = {
        id: customerId,
        accountId: accountId,
        isDirty: true,
        viewedAt: null,
        isRead: true // to ensure update of viewedAt
      };
      if (action == "messageArchive") {
        updateCustomer.messagesArchivedAt = new Date();
      } else if (action == "messageSnooze") {
        updateCustomer.messagesSnoozedUntil = actionDate;
      }

      if (!(action == "messageArchive" || action == "messageSnooze")) {
        store.dispatch("entities/customers/fetchCustomerDataJoins", {
          joins: null,
          customerId: customerId,
          startFresh: true
        });
      }

      store.dispatch("entities/customerLookups/update", {
        where: customerId,
        data: { viewedAt: Date.now() }
      });
      await store.dispatch("entities/customers/updateCustomer", updateCustomer);
    }
  }
};

async function fetchNext({ store, offset, lastDateTime = 0 }) {
  try {
    let response = await axios({
      method: "get",
      url:
        API_BASE_URL +
        `/customer?updatedAt[$gt]=${lastDateTime}&$limit=${FETCH_LIMIT_CUSTOMER}&$skip=${offset}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("access_token")}`
      }
    });
    const obj = response.data;
    const maxRows = response.total;
    let customers = [];
    obj.forEach(function(customer) {
      customers.push({
        accountId: customer.accountId,
        id: customer.id,
        isDirty: false,
        firstName: customer.firstName,
        middleName: customer.middleName,
        lastName: customer.lastName,
        companyName: customer.companyName,
        isBusiness: customer.isBusiness,
        createdAt: customer.createdAt,
        updatedAt: customer.updatedAt,
        viewedAt: customer.viewedAt
      });
    });
    if (customers.length > 0) {
      store.dispatch("entities/customers/insert", {
        data: customers
      });
    }
    store.dispatch("entities/settings/setIsOffline", false);
    if (maxRows > FETCH_LIMIT_CUSTOMER + offset) {
      await fetchNext({
        store,
        offset: FETCH_LIMIT_CUSTOMER + offset,
        lastDateTime
      });
    }
  } catch (error) {
    store.dispatch("entities/settings/setIsOffline", true);
  }
}
